export default __webpack_public_path__ + "static/media/switch-simp-img.7db884fd.webp";